import Axios from "@app/api/axios";

const createInvoice = (payload) => Axios.post("/invoices", payload);

export default createInvoice;
